<template>
  <div class="operator-step-three_block">
    <div class="left">
      <h3 class="large_blue_label">3. 打合せ</h3>
      <p>マッチングが成立した後は、作業内容、契約内容を確認するため、オペレーターとクライアントで打ち合わせをお願いします。</p>
      <br>
      <p class="marker-underline_label">まずは、フルーが提供するメッセージフォームを利用して連絡を取ってみてください。</p>
      <br>
      <p>必要に応じて電話や各種ビデオ会議ツールを利用して詳細の確認をお願いします。</p>
    </div>
    <div class="right">
      <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps_3.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "OperatorStepThreeBlock"
  }
</script>

<style lang="scss" scoped>
  .operator-step-three_block {
    @include double_columns(40%, 35%);

    @media screen and (max-width: 767px) {
      > .right > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>